import React from 'react'
const AuthUserContext = React.createContext(null)
const UserProfileContext = React.createContext(null)
const ModulesContext = React.createContext(null)
const CustomerdataContext = React.createContext(null)
export default AuthUserContext
export { AuthUserContext, UserProfileContext, ModulesContext, CustomerdataContext }
